import { render, staticRenderFns } from "./reserveBoard.vue?vue&type=template&id=5b970750&scoped=true&"
import script from "./reserveBoard.vue?vue&type=script&lang=js&"
export * from "./reserveBoard.vue?vue&type=script&lang=js&"
import style0 from "./reserveBoard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./reserveBoard.vue?vue&type=style&index=1&id=5b970750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b970750",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VImg,VLayout,VSpacer})
